module.exports = __webpack_public_path__ + "img/swimming.c142ca5f.png";